module.exports = __webpack_public_path__ + "img/07.efd952d0.png";